import React, { useState } from "react";
import "./HomeHeader.css";
import AppBar from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate, useLoaderData, useLocation } from "react-router-dom";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import logo from "../../assets/mooring-mate-logo.png";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import ListItemIcon from "@mui/material/ListItemIcon";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import InstagramIcon from "@mui/icons-material/Instagram";
import toast from "react-hot-toast";
import { logout } from "../../services";

const navItems = ["Home", "About", "How It Works", "FAQ", "Blog"];

export const MooringMateHomeHeader = (props) => {
  const user = useLoaderData();
  const navigate = useNavigate();
  const location = useLocation();

  const { window } = props;
  const drawerWidth = 240;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const data = useLoaderData();
  const baseUrl = process.env.REACT_APP_API_URL;

  const handleLogout = async () => {
    const res = await logout(user.token);

    if(res === null) {
      toast.error("Logout failed, Something went wrong please try again later");
      return;
    }

    if(res?.status === false) {
      toast.error(res?.message);
      return;
    }

    localStorage.removeItem("dockingmate");
    sessionStorage.removeItem("dockingmate");
    
    // Refresh the current page
    navigate(0);
    return;
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileNavigation = (path) => {
    navigate(path);
    return;
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle}>
      <Typography variant="h6" sx={{ my: 2 }}>
        <div className="mob-brand">
          <Link href="/">
            <img alt="" src={logo} />
          </Link>
        </div>
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton onClick={() => handleNavClick(item)}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}

        {user && (
          <Button onClick={() => navigate("/home")} sx={{ color: "#000" }}>
            Dashboard
          </Button>
        )}

        {user ? (
          <>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleProfileNavigation("/home/profile")}
              >
                <ListItemText primary={"Profile"} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleProfileNavigation("/home/payment-account")}
              >
                <ListItemText primary={"Account Info"} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                onClick={handleLogout}
              >
                <ListItemText primary={"Logout"} />
              </ListItemButton>
            </ListItem>
          </>
        ) : (
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => navigate("/login")}
            >
              <ListItemText primary={"Login"} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const primaryTheme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#ebebeb",
      },
    },
  });

  const handleNavClick = (item) => {
    // console.log("clicked: ", item);

    if (item === "Blog") {
      navigate("/blog");
      return;
    }

    if (item === "Home") {
      navigate("/");
      return;
    }

    if (item === "About") {
      navigate("/about-us");
      return;
    }

    if (item === "How It Works") {
      navigate("/how-it-works");
      return;
    }

    if (item === "Login") {
      navigate("/login");
      return;
    }

    if (item === "FAQ") {
       if (location.pathname === "/") {
        const faqSection = document.getElementById("faq");
        if (faqSection) {
          if (faqSection.classList.contains("hideFaq")) {
            faqSection.classList.remove("hideFaq");
          }

          faqSection.classList.add("showFaq");
          faqSection.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        navigate("/#faq");
      }
      return;
    }

    return;
  };

  return (
    <>
      <ThemeProvider theme={primaryTheme}>
        <AppBar component="nav">
          <Toolbar>
            <IconButton
              className="menu-icon"
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <div className="mob-head-brand">
              <Link href="/">
                <img alt="" src={logo} />
              </Link>
            </div>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
            >
              <div className="brand">
                <Link href="/">
                  <img alt="" src={logo} />
                </Link>
              </div>
            </Typography>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              {navItems.map((item) => (
                <Button
                  onClick={() => handleNavClick(item)}
                  key={item}
                  sx={{ color: "#000" }}
                >
                  {item}
                </Button>
              ))}

              {user && (
                <Button
                  onClick={() => navigate("/home")}
                  sx={{ color: "#000" }}
                >
                  Dashboard
                </Button>
              )}

              <IconButton aria-label="instagram" className="insta-btn" color="error">
                <Link
                  href="https://www.instagram.com/mooringmate24/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon color="error" sx={{ color: "#000" }} fontSize="inherit" />
                </Link>
              </IconButton>

              {user ? (
                <Tooltip title="Account settings">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    {data?.data?.profileImagePath ? (
                      <Avatar
                        src={`${baseUrl}${data?.data?.profileImagePath}`}
                        sx={{ width: 32, height: 32 }}
                      ></Avatar>
                    ) : (
                      <Avatar sx={{ width: 32, height: 32 }}></Avatar>
                    )}
                  </IconButton>
                </Tooltip>
              ) : (
                <Button
                  onClick={() => navigate("/login")}
                  // key={item}
                  sx={{ color: "#000" }}
                >
                  Login
                </Button>
              )}
            </Box>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      </ThemeProvider>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            padding: "10px",
            borderRadius: "10px",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => handleProfileNavigation("/home/profile")}
          PaperProps={{
            sx: {
              borderRadius: "10px",
            },
          }}
        >
          {data?.data?.profileImagePath ? (
            <Avatar
              src={`${baseUrl}${data?.data?.profileImagePath}`}
              sx={{ width: 32, height: 32 }}
            ></Avatar>
          ) : (
            <Avatar sx={{ width: 32, height: 32 }}></Avatar>
          )}{" "}
          Profile
        </MenuItem>
        <MenuItem
          onClick={() => handleProfileNavigation("/home/payment-account")}
        >
          <ListItemIcon>
            <AccountBalanceIcon fontSize="small" />
          </ListItemIcon>
          Account Info
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};
